export default function () {
  const widgetName = 'registerNowButton';
  const widgetOpts = registerNowButtonOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {

        $(`#${widgetName} .card-widget-item`).each(function () {
          $(this).wrapAll(`<a href=${(slide.items)[0].URL} class="button">${(slide.items)[0].Title}</a>`)
        })

      }

      customWidget()

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });
}